"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Text2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _SocialButton = _interopRequireDefault(require("@kiwicom/orbit-components/lib/SocialButton"));
var _LoginViaSocials = _interopRequireDefault(require("../../LoginViaSocials"));
var _Header = _interopRequireDefault(require("../../Header/Header"));
var _context = require("../../../../../services/intl/context");
var _jsxRuntime = require("react/jsx-runtime");
var _Text, _FormattedMessage, _FormattedMessage2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Intro = ({
  disableSocialLogin,
  onAppleLogin,
  onGoogleLogin,
  onFacebookLogin,
  onEmailLogin,
  onIncorrectEmail,
  googleError,
  facebookError,
  customTitle,
  customDescription
}) => {
  const intl = (0, _reactIntl.useIntl)();
  const {
    language
  } = (0, _context.useIntl)();
  const enabledSocialLogin = !disableSocialLogin;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {
      title: customTitle !== null && customTitle !== void 0 ? customTitle : intl.formatMessage({
        id: "account.login_title.continue_to_account"
      }),
      description: customDescription !== null && customDescription !== void 0 ? customDescription : intl.formatMessage({
        id: "account.login_description"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ModalSection.default, {
      dataTest: "MagicLogin-Intro",
      children: [_Text || (_Text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
        weight: "bold",
        size: "large",
        spaceAfter: "small",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.login.continue"
        })
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        align: "center",
        direction: "column",
        spaceAfter: "medium",
        spacing: "small",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialButton.default, {
          type: "email",
          dataTest: "MagicLogin-LoginViaEmail",
          onClick: onEmailLogin,
          fullWidth: true,
          children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.login.email"
          }))
        }), enabledSocialLogin && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginViaSocials.default, {
          onAppleLogin: onAppleLogin,
          onGoogleLogin: onGoogleLogin,
          onFacebookLogin: onFacebookLogin,
          googleError: googleError,
          facebookError: facebookError
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
          type: "secondary",
          size: "small",
          dataTest: "MagicLogin-IncorrectEmail",
          onClick: onIncorrectEmail,
          children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.incorrect_booking_email"
          }))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
          type: "secondary",
          size: "small",
          dataTest: "MagicLogin-LegalText",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.login_privacy_policy",
            values: {
              a1: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                href: `/${language.id}/pages/content/terms`,
                rel: "noreferrer noopener",
                target: "_blank",
                children: text
              }),
              a2: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                href: `/${language.id}/pages/content/privacy`,
                rel: "noreferrer noopener",
                target: "_blank",
                children: text
              })
            }
          })
        })]
      })]
    })]
  });
};
var _default = Intro;
exports.default = _default;